module.exports = __webpack_public_path__ + "static/411-a27d23dc3932f2fd50d5dffa87990fe7.png";